<template>
<div :class="$style['after-sales-message']">
    <pt-sub-title :title="title">
        <div @click="foldContent" v-if="isFoldContent">
            <i class="el-icon-caret-top" v-if="isShowContent"></i>
            <i class="el-icon-caret-bottom" v-else></i>
        </div>
    </pt-sub-title>
    <table class="goods-message-after-table" :class="isTablePadding?'fter-sales-message-table-padding':''" v-if="isShowContent">
        <tr>
            <td :style="{width:tdMaxWidth+'px'}">售后政策：</td>
            <td>{{goodsData.afterSalesPolicyName}}</td>
        </tr>
        <tr class="has-buttom-border">
            <td  :style="{width:tdMaxWidth+'px'}">内容：</td>
            <td><div v-if="goodsData.afterSalesPolicy" :class="$style['after-sale-content']" v-html="goodsData.afterSalesPolicy"></div></td>
        </tr>
        <tr  class="carriage-policy-top">
            <td :style="{width:tdMaxWidth+'px'}">运费规则：</td>
            <td>{{goodsData.carriagePolicyName}}</td>
        </tr>
        <tr class="has-buttom-border">
            <td  :style="{width:tdMaxWidth+'px'}">内容：</td>
            <td>{{goodsData.carriagePolicy}}</td>
        </tr>
        <tr  class="carriage-policy-top" :class="$style['privacy-policy-tr']">
            <td :style="{width:tdMaxWidth+'px'}">隐私条款：</td>
            <td >{{goodsData.privacyPolicyName}}<el-button type="text" @click="review" v-if="hasPrivacyPolicy">查看</el-button></td>
        </tr>
    </table>
    <el-dialog :visible="isDialog" :class="$style['privacy-policy-dialog']" @close="closeDialog">
        <privacy-policy-content v-if="isPrivacyPolicy" :privacyPolicyId="goodsData.privacyPolicyId"></privacy-policy-content>
    </el-dialog>
</div>
</template>
<script>
import privacyPolicyContent from './privacy-policy-content'
export default {
  components: {
    privacyPolicyContent
  },
  props: {
    title: {
      type: String,
      default: '售后政策'
    },
    goodsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    tdMaxWidth: {
      type: [Number, String],
      default: 0
    },
    from: {
      type: String,
      default: 'mall'
    }
  },
  computed: {
    isDialog: {
      set: function (val) {
        this.isPrivacyPolicy = val
      },
      get: function () {
        return this.isPrivacyPolicy
      }
    },
    // 表格是否需要左右padding
    isTablePadding () {
      return this.from === 'order'
    },
    // 内容是否需要折叠
    isFoldContent () {
      return this.from === 'order'
    },
    // 是否有隐私条款
    hasPrivacyPolicy () {
      return this.goodsData.privacyPolicyId
    }
  },
  data () {
    return {
      isPrivacyPolicy: false,
      isShowContent: true
    }
  },
  methods: {
    foldContent () {
      this.isShowContent = !this.isShowContent
    },
    review () {
      this.isPrivacyPolicy = true
    },
    closeDialog () {
      this.isPrivacyPolicy = false
    }
  }

}
</script>
<style module lang="less">
@import "~less/var";
.after-sales-message{
    overflow-x: hidden;
     :global
    .goods-message-after-table{
        padding-bottom: 10px;
        width: 100%;
        overflow-x: hidden;
        display: block;
        tr{
            display :flex;
            .goods-url-td{
                line-height: 40px;
                color: red;
            }
            td{
                line-height: 30px;
                font-size: 14px;
                .goods-url-div{
                    color: red;
                    justify-content: flex-start;
                }
                .goods-url-text{
                    color: red;
                    margin-right: 10px;
                }
                .el-button--primary{
                    span{
                        color: #fff
                    }
                }
                &:last-child{
                    flex: 1
                }
            }
            >:first-child{
                display: flex;
                color:@mainColor;
                justify-content: flex-end;
                white-space: nowrap;
            }
        }

.has-buttom-border{
    padding-bottom:10px;
   border-bottom: 1px solid #C6C9D3;
}
.carriage-policy-top{
    padding-top:10px
}
 ul,li{
        list-style-type:initial!important;
    }
    p,ul,ol{
        margin: inherit;
        margin-block-start:inherit;
        margin-block-end:inherit;
        line-height: inherit
    }
    }
}

.after-sale-content{
    padding: 10px 20px;
    width: 100%;
    background-color: #F9F9F9;
    overflow-x: auto;
    display: block!important;
    box-sizing: border-box;
    color: #2D2D2D!important;
    white-space: inherit!important;
    justify-content: flex-start!important;
    *{
        color: inherit
    }
}
.privacy-policy-tr{
    :global
    td{
        display: flex;
        line-height: 40PX!important;
        .el-button{
            margin-left: 10px;
        }
    }
}
.privacy-policy-dialog{
    :global
    .el-dialog{
        height: 80%;
        display: flex;
        flex-direction: column;
        .el-dialog__body{
            display: flex;
            flex: 1;
            overflow-y: auto
        }
    }

}
</style>
<style lang="less">
.fter-sales-message-table-padding{
    padding:20px
}
</style>
